<template>
  <pui-flex
    class="dam-error"
    direction="column"
    justifyContent="center"
    alignItems="center"
    flex="1"
  >
    <p class="dam-error__message">
      <p>{{ $t('dam.error.message') }}</p>
      <a @click="goBack" class="dam-error__message-link pui-link">
        {{ $t('dam.error.return') }}
      </a>
    </p>
  </pui-flex>
</template>

<script>
export default {
  methods: {
    /**
     * Pushes to the route before we had this error
     * by using the 'back' query of the current route
     *
     * @returns {void}
     */
    goBack() {
      const backName = this.$router.currentRoute.query.back;
      if (backName) {
        this.$router.push({ name: backName });
      } else {
        this.$router.push('/');
      }
    }
  }
};
</script>
